
import Assistenza from "../pages/Assistenza";
import Layout1 from "../pages/Layout1"
import Noleggio from "../pages/Noleggio";
import ServiziMain from '../pages/ServiziMain';
import Vendita from '../pages/Vendita';
import Ricambi from '../pages/Ricambi';
import ContactPage from "../pages/ContactPage";
import PrivacyPolicy from "../pages/PrivacyPolicy";

  const Routes = [
    { path: "/", component: <Layout1 /> },
    { path: "/servizi", component: <ServiziMain /> },
    { path: "/servizi/Assistenza", component: <Assistenza /> },
    { path: "/servizi/Noleggio", component: <Noleggio /> },
    { path: "/servizi/Vendita", component: <Vendita /> },
    { path: "/servizi/Ricambi", component: <Ricambi /> },
    { path: "/contatti", component: <ContactPage /> },
    { path: "/privacy-policy", component: <PrivacyPolicy /> },
  ];
  
  export default Routes;